<template>
    <div class="fhv-centent" v-loading="loading" >
        <h4 class="title-topic">Statistics - LAN</h4>
    
  <el-table
    :data="lanData"
    style="width: 100%" stripe border class="fhv-table">
    <el-table-column label="">
        <el-table-column
            prop="port"
            label="Port"
            >
         </el-table-column>
    </el-table-column>
    <el-table-column label="Received">
        <el-table-column
          prop="reBytes"
          label="Bytes"
          style="background-color:#7F8C9B;"
         >
        </el-table-column>
        <el-table-column
          prop="rePackets"
          label="Packets"
          >
        </el-table-column>
        <el-table-column
          prop="reError"
          label="Error"
          >
        </el-table-column>
        <el-table-column
          prop="reDiscard"
          label="Discard"
          >
        </el-table-column>
    </el-table-column>
    <el-table-column label="Transmitted">
        <el-table-column
          prop="trBytes"
          label="Bytes"
          >
        </el-table-column>
        <el-table-column
          prop="trPackets"
          label="Packets"
          >
        </el-table-column>
        <el-table-column
          prop="trError"
          label="Error"
          >
        </el-table-column>
        <el-table-column
          prop="trDiscard"
          label="Discard"
          >
        </el-table-column>
    </el-table-column>
  </el-table>

     <h4 class="title-topic">Statistics - WLAN</h4>
         <el-table
    :data="wanData"
    style="width: 100%" stripe border class="fhv-table">
    <el-table-column label="">
        <el-table-column
            prop="port"
            label="Port"
            >
         </el-table-column>
    </el-table-column>
    <el-table-column label="Received">
        <el-table-column
          prop="reBytes"
          label="Bytes"
          style="background-color:#7F8C9B;"
         >
        </el-table-column>
        <el-table-column
          prop="rePackets"
          label="Packets"
          >
        </el-table-column>
        <el-table-column
          prop="reError"
          label="Error"
          >
        </el-table-column>
        <el-table-column
          prop="reDiscard"
          label="Discard"
          >
        </el-table-column>
    </el-table-column>
    <el-table-column label="Transmitted">
        <el-table-column
          prop="trBytes"
          label="Bytes"
          >
        </el-table-column>
        <el-table-column
          prop="trPackets"
          label="Packets"
          >
        </el-table-column>
        <el-table-column
          prop="trError"
          label="Error"
          >
        </el-table-column>
        <el-table-column
          prop="trDiscard"
          label="Discard"
          >
        </el-table-column>
    </el-table-column>
  </el-table>
    </div>
</template>

<script>
export default {
  data() {
    return {
      loading:false,
      lanData: [],
      wanData: []
    };
  },
  methods: {
    statistics() {
      let _this = this;
      let statistics = {
        data: {
          lan: [],
          wlan: []
        },
        getData: function() {
          this.loading=true;
          axios.post("/boafrm/getNetStatistics").then(res => {
            this.loading=false;
            if (res.data == "undefined" || res.data == "") {
              return;
            }
            statistics.data = res.data.statisticsData;
            statistics.setDataToHtml();
          });
        },
        setDataToHtml: function() {
        const lanNum = _this.$G_DEVICE_CFG.lanNum;
          var lanData = statistics.data.lan;
           _this.lanData=[];
           
          for (var index = 0; index < lanData.length; index++) {
            if(lanNum <= 2 && index < 2) continue;
            let lanName
            if(lanNum <= 2)
                lanName = `LAN${index - 1}`
            else
                lanName = `LAN${index + 1}`
            _this.lanData.push({
                port:lanName,
                reBytes: lanData[index].rx.Bytes ,
                rePackets:  lanData[index].rx.Packets,
                reError: lanData[index].rx.Error,
                reDiscard: lanData[index].rx.Discard ,
                trBytes: lanData[index].tx.Bytes,
                trPackets:  lanData[index].tx.Packets,
                trError: lanData[index].tx.Error,
                trDiscard:  lanData[index].tx.Discard,
            })
          }

          var wlanData = statistics.data.wlan;
           _this.wanData=[];
          for (var index = 0; index < wlanData.length; index++) {
            _this.wanData.push({
               port:wlanData[index].port,
                reBytes: wlanData[index].rx.Bytes,
                rePackets: wlanData[index].rx.Packets,
                reError:  wlanData[index].rx.Error ,
                reDiscard:  wlanData[index].rx.Discard,
                trBytes:  wlanData[index].tx.Bytes,
                trPackets:  wlanData[index].tx.Packets,
                trError: wlanData[index].tx.Error,
                trDiscard: wlanData[index].tx.Discard,
            });
         
          }
        }
      };
      return statistics;
    }
  },
  created(){
    var _this=this;
    this.statistics().getData();
        // 每10s查询一次
     this.timer = setInterval(function () { 
            _this.statistics().getData();
        }, 10000);
  },
  beforeDestroy(){
    clearInterval(this.timer);
  },
};
</script>





